import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "g-container pl-[16px] sm:pl-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl sm:text-4xl leading-[50px] font-normal text-gary-line-color pt-[20px]" }, " 我的禮物清單 ", -1)
const _hoisted_3 = { class: "shopping-cart-breadcrumb leading-[18px] items-center flex gap-3 text-xs sm:text-[13px] font-bold flex mb-[21px] mt-1.5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex items-center mb-[6px] leading-[26px] text-gary-text-color tracking-[.06em]"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 全部禮物 ")
const _hoisted_8 = { class: "g-container" }
const _hoisted_9 = { class: "flex flex-col sm:flex-row gap-5 sm:gap-2.5 mt-2.5" }
const _hoisted_10 = { class: "grow" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-2.5"
}
const _hoisted_12 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_13 = { class: "flex my-5" }
const _hoisted_14 = { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "grow flex flex-col" }
const _hoisted_17 = { class: "flex ml-[30px]" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_20 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_21 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_22 = { class: "hidden" }
const _hoisted_23 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_25 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_27 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "grow h-[60px] flex items-center" }
const _hoisted_33 = { class: "grow mr-[10px]" }
const _hoisted_34 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_35 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_36 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_37 = {
  key: 0,
  class: "flex"
}
const _hoisted_38 = { class: "grow ml-[180px] flex flex-col" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "w-[46%]" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "w-[20px] mr-1.5" }
const _hoisted_43 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_44 = { class: "flex mb-[20px]" }
const _hoisted_45 = { class: "w-[80px] mr-[20px]" }
const _hoisted_46 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_48 = { class: "grow flex" }
const _hoisted_49 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "w-[22%] ml-[30px]" }, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_52 = { class: "flex pt-[20px] bg-img-background" }
const _hoisted_53 = {
  key: 0,
  class: "w-[70px]"
}
const _hoisted_54 = {
  key: 1,
  class: "w-[50px]"
}
const _hoisted_55 = { class: "w-[80px]" }
const _hoisted_56 = { class: "grow flex flex-col" }
const _hoisted_57 = { class: "flex ml-[30px]" }
const _hoisted_58 = { class: "w-[46%]" }
const _hoisted_59 = { class: "flex" }
const _hoisted_60 = { class: "w-[20px] mr-1.5" }
const _hoisted_61 = { class: "flex hidden" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("ul", { class: "list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_63 = { class: "grow h-[60px] flex items-center" }
const _hoisted_64 = { class: "grow mr-[10px]" }
const _hoisted_65 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_66 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_67 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_68 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_69 = {
  key: 0,
  class: "w-[70px]"
}
const _hoisted_70 = {
  key: 1,
  class: "w-[50px]"
}
const _hoisted_71 = { class: "w-[80px]" }
const _hoisted_72 = { class: "grow flex flex-col" }
const _hoisted_73 = { class: "flex ml-[30px]" }
const _hoisted_74 = { class: "w-[46%]" }
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = { class: "w-[20px] mr-1.5" }
const _hoisted_77 = { class: "flex hidden" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("ul", { class: "list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_79 = { class: "grow h-[60px] flex items-center" }
const _hoisted_80 = { class: "grow mr-[10px]" }
const _hoisted_81 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_82 = {
  key: 0,
  class: "flex w-[22%] mr-[30px] justify-end"
}
const _hoisted_83 = { class: "flex justify-end my-1.5" }
const _hoisted_84 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_86 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_87 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_88 = { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "grow flex flex-col" }
const _hoisted_91 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_92 = { class: "flex flex-col gap-1" }
const _hoisted_93 = { class: "flex flex-row justify-between" }
const _hoisted_94 = { class: "" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_98 = { class: "hidden" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_103 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_104 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_107 = [
  _hoisted_104,
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_109 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_110 = { class: "mr-[16px]" }
const _hoisted_111 = {
  key: 0,
  class: "text-xs items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_112 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_113 = {
  key: 0,
  class: "flex flex-row mb-3"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[46px]" }, null, -1)
const _hoisted_115 = { class: "w-[60px]" }
const _hoisted_116 = { class: "grow flex flex-col" }
const _hoisted_117 = { class: "flex flex-col ml-[6px]" }
const _hoisted_118 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_119 = { class: "flex flex-row justify-between" }
const _hoisted_120 = { class: "" }
const _hoisted_121 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_122 = { class: "flex" }
const _hoisted_123 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_125 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_126 = { class: "mr-[16px]" }
const _hoisted_127 = {
  key: 0,
  class: "text-xs sm:leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_128 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_129 = {
  key: 1,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_130 = { class: "bg-img-background flex pt-[20px] flex-row pt-5 pb-5" }
const _hoisted_131 = {
  key: 0,
  class: "ml-[46px]"
}
const _hoisted_132 = {
  key: 1,
  class: "ml-[26px]"
}
const _hoisted_133 = { class: "w-[60px]" }
const _hoisted_134 = { class: "grow flex flex-col" }
const _hoisted_135 = { class: "flex flex-col ml-[6px]" }
const _hoisted_136 = { class: "flex flex-col gap-1" }
const _hoisted_137 = { class: "flex flex-row justify-between" }
const _hoisted_138 = { class: "max-w-[180px]" }
const _hoisted_139 = { class: "flex" }
const _hoisted_140 = { class: "w-[20px] mr-1.5" }
const _hoisted_141 = { class: "items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_143 = {
  key: 0,
  class: "flex gap-1 mt-0.5 mr-[16px] justify-end"
}
const _hoisted_144 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_145 = { class: "mr-[16px]" }
const _hoisted_146 = { class: "text-xs items-center text-light-gary-text-color line-through text-right" }
const _hoisted_147 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_148 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_149 = {
  key: 0,
  class: "ml-[46px]"
}
const _hoisted_150 = {
  key: 1,
  class: "ml-[26px]"
}
const _hoisted_151 = { class: "w-[60px]" }
const _hoisted_152 = { class: "grow flex flex-col" }
const _hoisted_153 = { class: "flex flex-col ml-[6px]" }
const _hoisted_154 = { class: "flex flex-col gap-1" }
const _hoisted_155 = { class: "flex flex-row justify-between" }
const _hoisted_156 = { class: "max-w-[180px]" }
const _hoisted_157 = { class: "flex" }
const _hoisted_158 = { class: "w-[20px] mr-1.5" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_160 = {
  key: 0,
  class: "flex gap-1 mt-0.5 mr-[16px] justify-end"
}
const _hoisted_161 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_162 = { class: "mr-[16px]" }
const _hoisted_163 = { class: "text-xs items-center text-light-gary-text-color line-through text-right" }
const _hoisted_164 = { class: "flex justify-end mx-[16px] my-3" }
const _hoisted_165 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_167 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_168 = { class: "w-[20px] mr-2.5" }
const _hoisted_169 = /*#__PURE__*/_createTextVNode(" 滿額加購")
const _hoisted_170 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_171 = { class: "flex mt-5" }
const _hoisted_172 = { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }
const _hoisted_173 = ["onClick"]
const _hoisted_174 = { class: "grow flex flex-col" }
const _hoisted_175 = { class: "flex ml-[30px]" }
const _hoisted_176 = ["onClick"]
const _hoisted_177 = { class: "flex text-base font-medium text-gary-text-color" }
const _hoisted_178 = { class: "mr-1.5 w-[20px]" }
const _hoisted_179 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_180 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_181 = { class: "hidden" }
const _hoisted_182 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_183 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_184 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_185 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_186 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_187 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_190 = [
  _hoisted_187,
  _hoisted_188,
  _hoisted_189
]
const _hoisted_191 = { class: "grow h-[60px] flex items-center" }
const _hoisted_192 = { class: "grow mr-[10px]" }
const _hoisted_193 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_194 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_195 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_196 = { class: "flex justify-end my-1.5" }
const _hoisted_197 = { class: "hidden ml-[24px] my-1.5 flex leading-[17px] items-center gap-1.5 text-xs text-primary-color cursor-pointer" }
const _hoisted_198 = /*#__PURE__*/_createTextVNode("點選看更多優惠 ")
const _hoisted_199 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_201 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_202 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_203 = { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }
const _hoisted_204 = ["onClick"]
const _hoisted_205 = { class: "grow flex flex-col" }
const _hoisted_206 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_207 = { class: "flex flex-col gap-1" }
const _hoisted_208 = { class: "flex flex-row justify-between" }
const _hoisted_209 = { class: "" }
const _hoisted_210 = ["onClick"]
const _hoisted_211 = { class: "mr-1.5 w-[20px]" }
const _hoisted_212 = ["onClick"]
const _hoisted_213 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_214 = { class: "hidden" }
const _hoisted_215 = { key: 0 }
const _hoisted_216 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_217 = { key: 1 }
const _hoisted_218 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_219 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_220 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_223 = [
  _hoisted_220,
  _hoisted_221,
  _hoisted_222
]
const _hoisted_224 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_225 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_226 = { class: "mr-[16px]" }
const _hoisted_227 = {
  key: 0,
  class: "text-xs items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_228 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_229 = { class: "flex justify-end mx-[16px] my-3" }
const _hoisted_230 = { class: "hidden flex leading-[17px] items-center gap-1.5 text-xs text-primary-color cursor-pointer" }
const _hoisted_231 = /*#__PURE__*/_createTextVNode("點選看更多優惠 ")
const _hoisted_232 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_234 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_235 = { class: "w-[20px] mr-2.5" }
const _hoisted_236 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_237 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_238 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_239 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] items-center" }, null, -1)
const _hoisted_240 = { class: "w-[80px]" }
const _hoisted_241 = { class: "grow flex flex-col" }
const _hoisted_242 = { class: "flex ml-[30px]" }
const _hoisted_243 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_244 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_245 = { class: "mr-1.5 w-[20px]" }
const _hoisted_246 = { class: "text-[13px] ml-[26px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_247 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_248 = { class: "hidden" }
const _hoisted_249 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_250 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_251 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_252 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_253 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_254 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_255 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_256 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_257 = [
  _hoisted_254,
  _hoisted_255,
  _hoisted_256
]
const _hoisted_258 = { class: "grow h-[60px] pl-[50px] flex items-center" }
const _hoisted_259 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_260 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_261 = { class: "flex flex-row h-[80px] mx-[23px] items-center" }
const _hoisted_262 = ["onClick"]
const _hoisted_263 = { class: "grow flex flex-col" }
const _hoisted_264 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_265 = { class: "flex flex-col gap-1" }
const _hoisted_266 = { class: "flex flex-row justify-between" }
const _hoisted_267 = { class: "" }
const _hoisted_268 = ["onClick"]
const _hoisted_269 = ["onClick"]
const _hoisted_270 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_271 = { class: "hidden" }
const _hoisted_272 = { key: 0 }
const _hoisted_273 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_274 = { key: 1 }
const _hoisted_275 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_276 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_277 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_278 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_279 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_280 = [
  _hoisted_277,
  _hoisted_278,
  _hoisted_279
]
const _hoisted_281 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_282 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_283 = {
  key: 1,
  class: "flex flex-col gap-2.5"
}
const _hoisted_284 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_285 = { class: "flex mt-5" }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_287 = ["onClick"]
const _hoisted_288 = { class: "grow flex flex-col" }
const _hoisted_289 = { class: "flex ml-[30px]" }
const _hoisted_290 = ["onClick"]
const _hoisted_291 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_292 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_293 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_294 = { class: "hidden" }
const _hoisted_295 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_296 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_297 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_298 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_299 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_300 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_301 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_302 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_303 = [
  _hoisted_300,
  _hoisted_301,
  _hoisted_302
]
const _hoisted_304 = { class: "grow h-[60px] flex items-center" }
const _hoisted_305 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_306 = { class: "grow mr-7 flex" }
const _hoisted_307 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_308 = {
  key: 0,
  class: "text-[13px] ml-[10px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right"
}
const _hoisted_309 = {
  key: 0,
  class: "flex"
}
const _hoisted_310 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[30px]" }, null, -1)
const _hoisted_311 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[130px]" }, null, -1)
const _hoisted_312 = { class: "grow flex flex-col" }
const _hoisted_313 = { class: "flex" }
const _hoisted_314 = { class: "w-[46%]" }
const _hoisted_315 = { class: "flex" }
const _hoisted_316 = { class: "w-[20px] mr-1.5" }
const _hoisted_317 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_318 = { class: "flex mb-[20px]" }
const _hoisted_319 = { class: "w-[80px] mr-[20px]" }
const _hoisted_320 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "包裝盒 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "吊卡 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "貼紙 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "防塵袋 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "紙袋 x1")
], -1)
const _hoisted_322 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_323 = { class: "grow flex" }
const _hoisted_324 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right mr-[30px]" }
const _hoisted_325 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_326 = { class: "bg-img-background flex py-[20px]" }
const _hoisted_327 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_328 = { class: "w-[80px]" }
const _hoisted_329 = { class: "grow flex flex-col" }
const _hoisted_330 = { class: "flex ml-[30px]" }
const _hoisted_331 = { class: "w-[46%]" }
const _hoisted_332 = { class: "flex" }
const _hoisted_333 = { class: "w-[20px] mr-1.5" }
const _hoisted_334 = { class: "flex items-center mb-1.5 font-medium text-sm text-gary-text-color" }
const _hoisted_335 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
    /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
    /*#__PURE__*/_createElementVNode("li", null, "霧面")
  ])
], -1)
const _hoisted_336 = { class: "grow h-[60px] flex items-center" }
const _hoisted_337 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_338 = { class: "grow mr-[30px]" }
const _hoisted_339 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_340 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_341 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_342 = { class: "w-[80px]" }
const _hoisted_343 = { class: "grow flex flex-col" }
const _hoisted_344 = { class: "flex ml-[30px]" }
const _hoisted_345 = { class: "w-[46%]" }
const _hoisted_346 = { class: "flex" }
const _hoisted_347 = { class: "w-[20px] mr-1.5" }
const _hoisted_348 = { class: "flex" }
const _hoisted_349 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_350 = { class: "grow h-[60px] flex items-center" }
const _hoisted_351 = { class: "grow mr-[30px]" }
const _hoisted_352 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_353 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_354 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_355 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_356 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_357 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_358 = ["onClick"]
const _hoisted_359 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_360 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_361 = { class: "flex flex-col gap-1" }
const _hoisted_362 = { class: "flex flex-row justify-between" }
const _hoisted_363 = { class: "" }
const _hoisted_364 = ["onClick"]
const _hoisted_365 = ["onClick"]
const _hoisted_366 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_367 = { class: "hidden" }
const _hoisted_368 = { key: 0 }
const _hoisted_369 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_370 = { key: 1 }
const _hoisted_371 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_372 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_373 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_374 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_375 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_376 = [
  _hoisted_373,
  _hoisted_374,
  _hoisted_375
]
const _hoisted_377 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_378 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_379 = { class: "mr-[16px]" }
const _hoisted_380 = { class: "grow mr-7" }
const _hoisted_381 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_382 = {
  key: 0,
  class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right"
}
const _hoisted_383 = {
  key: 0,
  class: "flex flex-row mb-3"
}
const _hoisted_384 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_385 = { class: "w-[60px]" }
const _hoisted_386 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_387 = { class: "flex flex-col ml-[6px]" }
const _hoisted_388 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_389 = { class: "flex flex-row justify-between" }
const _hoisted_390 = { class: "" }
const _hoisted_391 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_392 = { class: "flex" }
const _hoisted_393 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_394 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_395 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_396 = { class: "mr-[16px]" }
const _hoisted_397 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_398 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_399 = { class: "bg-img-background flex flex-row pt-5 pb-5" }
const _hoisted_400 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_401 = { class: "w-[60px]" }
const _hoisted_402 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_403 = { class: "flex flex-col ml-[6px]" }
const _hoisted_404 = { class: "flex flex-col gap-1" }
const _hoisted_405 = { class: "flex flex-row justify-between" }
const _hoisted_406 = { class: "" }
const _hoisted_407 = { class: "flex items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_408 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_409 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_410 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_411 = { class: "mr-[16px]" }
const _hoisted_412 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_413 = {
  key: 3,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_414 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_415 = { class: "w-[60px]" }
const _hoisted_416 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_417 = { class: "flex flex-col ml-[6px]" }
const _hoisted_418 = { class: "flex flex-col gap-1" }
const _hoisted_419 = { class: "flex flex-row justify-between" }
const _hoisted_420 = { class: "" }
const _hoisted_421 = { class: "flex" }
const _hoisted_422 = { class: "w-[20px] mr-1.5" }
const _hoisted_423 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_424 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_425 = { class: "mr-[16px]" }
const _hoisted_426 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_427 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_428 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_429 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_430 = /*#__PURE__*/_createTextVNode("滿額加購 ")
const _hoisted_431 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_432 = { class: "flex mt-5" }
const _hoisted_433 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_434 = ["onClick"]
const _hoisted_435 = { class: "grow flex flex-col" }
const _hoisted_436 = { class: "flex ml-[30px]" }
const _hoisted_437 = ["onClick"]
const _hoisted_438 = { class: "flex text-base font-medium text-gary-text-color" }
const _hoisted_439 = { class: "mr-1.5 w-[20px]" }
const _hoisted_440 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_441 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_442 = { class: "hidden" }
const _hoisted_443 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_444 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_445 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_446 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_447 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_448 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_449 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_450 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_451 = [
  _hoisted_448,
  _hoisted_449,
  _hoisted_450
]
const _hoisted_452 = { class: "grow h-[60px] flex items-center" }
const _hoisted_453 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_454 = { class: "grow mr-7" }
const _hoisted_455 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_456 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_457 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_458 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_459 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_460 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_461 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_462 = ["onClick"]
const _hoisted_463 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_464 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_465 = { class: "flex flex-col gap-1" }
const _hoisted_466 = { class: "flex flex-row justify-between" }
const _hoisted_467 = { class: "" }
const _hoisted_468 = ["onClick"]
const _hoisted_469 = { class: "mr-1.5 w-[20px]" }
const _hoisted_470 = ["onClick"]
const _hoisted_471 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_472 = { class: "hidden" }
const _hoisted_473 = { key: 0 }
const _hoisted_474 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_475 = { key: 1 }
const _hoisted_476 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_477 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_478 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_479 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_480 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_481 = [
  _hoisted_478,
  _hoisted_479,
  _hoisted_480
]
const _hoisted_482 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_483 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_484 = { class: "mr-[16px]" }
const _hoisted_485 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_486 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_487 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_488 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_489 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_490 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_491 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_492 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_493 = { class: "flex flex-row h-[80px] ml-[25px] mr-[25px] items-center" }
const _hoisted_494 = { class: "w-[80px]" }
const _hoisted_495 = { class: "grow flex flex-col" }
const _hoisted_496 = { class: "flex ml-[30px]" }
const _hoisted_497 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_498 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_499 = { class: "mr-1.5 w-[20px]" }
const _hoisted_500 = { class: "ml-[26px] text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_501 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_502 = { class: "hidden" }
const _hoisted_503 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_504 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_505 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_506 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_507 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_508 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_509 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_510 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_511 = [
  _hoisted_508,
  _hoisted_509,
  _hoisted_510
]
const _hoisted_512 = { class: "grow h-[60px] pl-[60px] flex items-center" }
const _hoisted_513 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_514 = { class: "flex flex-row mt-5 mb-3 ml-[25px]" }
const _hoisted_515 = ["onClick"]
const _hoisted_516 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_517 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_518 = { class: "flex flex-col gap-1" }
const _hoisted_519 = { class: "flex flex-row justify-between" }
const _hoisted_520 = { class: "" }
const _hoisted_521 = { class: "flex text-[13px] font-medium text-gary-text-color" }
const _hoisted_522 = { class: "mr-1.5 w-[20px]" }
const _hoisted_523 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_524 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_525 = { class: "hidden" }
const _hoisted_526 = { key: 0 }
const _hoisted_527 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_528 = { key: 1 }
const _hoisted_529 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_530 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_531 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_532 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_533 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_534 = [
  _hoisted_531,
  _hoisted_532,
  _hoisted_533
]
const _hoisted_535 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_536 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_537 = {
  key: 0,
  class: "step1 basis-[29%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0"
}
const _hoisted_538 = { class: "bg-white rounded-md" }
const _hoisted_539 = { class: "m-[36px] flex flex-col divide-y-2" }
const _hoisted_540 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_541 = { class: "flex text-sm" }
const _hoisted_542 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "訂單金額", -1)
const _hoisted_543 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_544 = { class: "flex text-sm" }
const _hoisted_545 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "商品折扣", -1)
const _hoisted_546 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_547 = { class: "pt-[20px]" }
const _hoisted_548 = { class: "flex text-black-900-color leading-[23px] items-center pb-[20px]" }
const _hoisted_549 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_550 = { class: "grow text-lg text-right font-bold" }
const _hoisted_551 = { class: "bg-black-300-color rounded-full h-2 dark:bg-black-300-color" }
const _hoisted_552 = ["innerHTML"]
const _hoisted_553 = {
  key: 0,
  class: "flex flex-col bg-white rounded-md gap-[30px] p-[30px] pr-[20px]"
}
const _hoisted_554 = /*#__PURE__*/_createElementVNode("div", { class: "text-center sm:font-bold text-gary-text-color text-2xl" }, " 滿額加購 ", -1)
const _hoisted_555 = ["onClick"]
const _hoisted_556 = { class: "w-[80px] mr-2" }
const _hoisted_557 = { class: "flex justify-between w-full" }
const _hoisted_558 = { class: "min-h-10 mr-[14px]" }
const _hoisted_559 = { class: "font-normal text-[0.9375rem] text-gary-text-color mt-[0.125rem]" }
const _hoisted_560 = { class: "font-normal text-[0.875rem] text-gary-text-color" }
const _hoisted_561 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_562 = {
  key: 0,
  class: "orange-price ml-2 line-through text-light-gary-text-color"
}
const _hoisted_563 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_564 = { class: "flex items-center" }
const _hoisted_565 = { class: "flex flex-col bg-white rounded-md gap-[30px] p-[30px] pr-[20px]" }
const _hoisted_566 = /*#__PURE__*/_createElementVNode("div", { class: "text-center sm:font-bold text-gary-text-color text-2xl" }, " 您也喜歡 ", -1)
const _hoisted_567 = ["onClick"]
const _hoisted_568 = { class: "w-[80px] mr-2" }
const _hoisted_569 = { class: "flex justify-between w-full" }
const _hoisted_570 = { class: "min-h-10 mr-[14px]" }
const _hoisted_571 = { class: "font-normal text-[0.9375rem] text-gary-text-color mt-[0.125rem]" }
const _hoisted_572 = { class: "font-normal text-[0.8125rem] text-light-gary-text-color" }
const _hoisted_573 = { class: "font-normal text-[0.875rem] text-gary-text-color" }
const _hoisted_574 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_575 = {
  key: 0,
  class: "orange-price ml-2 line-through text-light-gary-text-color"
}
const _hoisted_576 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_577 = { class: "flex items-center" }
const _hoisted_578 = {
  key: 1,
  class: "basis-[38%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0"
}
const _hoisted_579 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px]" }
const _hoisted_580 = { class: "flex flex-col px-[20px] w-full" }
const _hoisted_581 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg text-gary-text-color pb-5" }, [
  /*#__PURE__*/_createTextVNode(" 訂購人資料"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-breadcrumb-color pl-3 tracking-[.1em] font-normal" }, "同會員資料")
], -1)
const _hoisted_582 = { class: "items-center text-sm text-left relative font-light pb-[20px] text-breadcrumb-color tracking-widest" }
const _hoisted_583 = /*#__PURE__*/_createTextVNode(" 手機 ")
const _hoisted_584 = { class: "pt-2 text-black-400-color" }
const _hoisted_585 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-breadcrumb-color pb-[20px]" }, " 訂單及發票資訊將用E-mail通知您，請確認資料的正確性 ", -1)
const _hoisted_586 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px]" }
const _hoisted_587 = { class: "px-[20px]" }
const _hoisted_588 = { class: "flex items-center justify-between" }
const _hoisted_589 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "運送方式", -1)
const _hoisted_590 = {
  key: 0,
  class: "text-xs text-dot-red"
}
const _hoisted_591 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_592 = { class: "flex gap-[22px] pb-2.5" }
const _hoisted_593 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_594 = { class: "text-gary-text-color tracking-[.06em]" }
const _hoisted_595 = {
  key: 0,
  class: "text-light-gary-text-color text-[13px] tracking-[.12em] grow"
}
const _hoisted_596 = {
  key: 1,
  class: "text-light-gary-text-color text-[13px] tracking-[.12em] grow"
}
const _hoisted_597 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_598 = { class: "flex gap-[10px]" }
const _hoisted_599 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_600 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_601 = { class: "flex gap-[22px]" }
const _hoisted_602 = { class: "text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_603 = { class: "flex gap-[7px]" }
const _hoisted_604 = { class: "text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_605 = {
  key: 0,
  class: "text-gary-text-color tracking-[.06em] text-sm"
}
const _hoisted_606 = {
  key: 2,
  class: "text-sm text-light-gary-text-color tracking-[.06em]"
}
const _hoisted_607 = {
  key: 3,
  class: "text-sm text-light-gary-text-color tracking-[.06em]"
}
const _hoisted_608 = { class: "flex items-center mr-2" }
const _hoisted_609 = { class: "inline-block relative rounded-[4px] border-black-300-color border-solid border-[1px] hover:border-black active:border-black w-full" }
const _hoisted_610 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px] divide-y-2" }
const _hoisted_611 = { class: "mb-[30px] px-[20px]" }
const _hoisted_612 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-bold text-lg text-gary-text-color" }, " 選擇付款方式 ", -1)
const _hoisted_613 = { class: "flex flex-col gap-2.5" }
const _hoisted_614 = { class: "pt-[36px] px-[20px]" }
const _hoisted_615 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg text-gary-text-color" }, "發票類型", -1)
const _hoisted_616 = { key: 0 }
const _hoisted_617 = /*#__PURE__*/_createStaticVNode("<ul class=\"list-none list-inside text-breadcrumb-color text-xs\"><li><div class=\"inline-flex\"><span>・</span><span class=\"whitespace-pre-wrap break-all\"> 發票依財政部規定託管，不再開立紙本，電子發票將以E-mail寄發 </span></div></li><li><div class=\"inline-flex\"><span>・</span><span class=\"whitespace-pre-wrap break-all\"> 依統一發票使用辦法規定，個人發票一經開立，不得更改或改開公司戶發票，可至 <a href=\"https://www.einvoice.nat.gov.tw/\">財政部電子發票流程說明</a> 查看詳情 </span></div></li><li></li></ul>", 1)
const _hoisted_618 = [
  _hoisted_617
]
const _hoisted_619 = { key: 1 }
const _hoisted_620 = { class: "mt-[20px] flex font-bold text-lg text-gary-text-color pb-5" }
const _hoisted_621 = /*#__PURE__*/_createTextVNode(" 手機條碼載具 ")
const _hoisted_622 = /*#__PURE__*/_createTextVNode("我同意紀錄手機條碼為常用載具 ")
const _hoisted_623 = { key: 2 }
const _hoisted_624 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[20px] mb-2.5 font-bold text-lg text-gary-text-color" }, " 統一編號 ", -1)
const _hoisted_625 = { class: "mt-[20px] flex font-bold text-lg text-gary-text-color pb-5" }
const _hoisted_626 = /*#__PURE__*/_createTextVNode(" E-mail ")
const _hoisted_627 = /*#__PURE__*/_createTextVNode(" 同會員資料 ")
const _hoisted_628 = { class: "bg-white rounded-md py-[36px] px-[24px] sm:px-[40px]" }
const _hoisted_629 = { class: "flex gap-3 text-primary-color" }
const _hoisted_630 = /*#__PURE__*/_createTextVNode("使用優惠卷 ")
const _hoisted_631 = { class: "flex items-center" }
const _hoisted_632 = { class: "flex flex-col divide-y-2" }
const _hoisted_633 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_634 = { class: "flex items-center" }
const _hoisted_635 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "訂單金額", -1)
const _hoisted_636 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_637 = { class: "flex" }
const _hoisted_638 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 w-[64px] text-clip font-medium pt-1" }, " 優惠卷 ", -1)
const _hoisted_639 = { class: "grow flex flex-col" }
const _hoisted_640 = {
  key: 0,
  class: "shrink-0 text-right font-medium sm:font-bold pt-1"
}
const _hoisted_641 = {
  key: 0,
  class: "flex text-xs max-w-[200px] text-white bg-primary-color mb-1.5 px-2.5 py-[6px] mx-2.5 rounded-2xl items-center leading-[18px]"
}
const _hoisted_642 = { class: "ml-[5px] w-[16px]" }
const _hoisted_643 = {
  key: 1,
  class: "text-right grow font-medium sm:font-bold pt-1"
}
const _hoisted_644 = { class: "flex items-center" }
const _hoisted_645 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費小計", -1)
const _hoisted_646 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_647 = { class: "flex items-center" }
const _hoisted_648 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費折抵", -1)
const _hoisted_649 = {
  key: 0,
  class: "flex text-xs text-white bg-primary-color px-2.5 py-[6px] mx-2.5 rounded-2xl items-center leading-[18px]"
}
const _hoisted_650 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_651 = { class: "pt-[20px]" }
const _hoisted_652 = { class: "flex text-black-900-color leading-[23px] items-center" }
const _hoisted_653 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_654 = { class: "grow text-lg text-right font-bold" }
const _hoisted_655 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 願意收到活動與優惠相關內容 ", -1)
const _hoisted_656 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 我同意辦理退貨時，由HORLaY代為處理電子發票及銷貨退回證明單，以加快退貨退款作業 ", -1)
const _hoisted_657 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 我已確認以上資訊正確無誤。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_Input = _resolveComponent("Input")!
  const _component_AddressInput = _resolveComponent("AddressInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AddOnModal = _resolveComponent("AddOnModal")!
  const _component_DeliveryListModal = _resolveComponent("DeliveryListModal")!
  const _component_SelectCouponModal = _resolveComponent("SelectCouponModal")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", {
          class: _normalizeClass(["tab first:ml-0", [{ actived: _ctx.step === 1 }]])
        }, " 01 購物車 ", 2),
        _hoisted_4,
        _createElementVNode("li", {
          class: _normalizeClass(["tab", [{ actived: _ctx.step === 2 }]])
        }, "02 運送資料&結帳", 2),
        _hoisted_5,
        _createElementVNode("li", {
          class: _normalizeClass(["tab", [{ actived: _ctx.step === 3 }]])
        }, "03 購物完成", 2)
      ]),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CheckBox, {
              modelValue: _ctx.getAllSelectValue,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allItemSelect(_ctx.getAllSelectValue))),
              class: "pr-2.5"
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.step == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderShoppingCartCmdyListRef, (shoppingCartItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: shoppingCartItem.OrderShoppingCartId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_CheckBox, {
                            modelValue: shoppingCartItem.Checked,
                            "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_15),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem)),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 1),
                              (!shoppingCartItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                        _hoisted_24,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                        _hoisted_26,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_27, _hoisted_31))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_18),
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_InputWithButton, {
                                style: {"width":"120px"},
                                maxNumber: 100,
                                modelValue: shoppingCartItem.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addClick(shoppingCartItem)),
                                onSubtractClick: ($event: any) => (_ctx.subtractClick(shoppingCartItem)),
                                onBlur: ($event: any) => (_ctx.itemUpdate(shoppingCartItem))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_33, [
                                (
                            shoppingCartItem.UnitFeeOri !==
                            shoppingCartItem.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeOri * shoppingCartItem.CmdyQty), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_35, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                (!shoppingCartItem.IsEndProduct)
                                  ? (_openBlock(), _createBlock(_component_Icon, {
                                      key: 0,
                                      iconName: "circle_edit",
                                      onClick: ($event: any) => (_ctx.continueEdit(shoppingCartItem)),
                                      width: '20px'
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_FavoriteButton, {
                                  onClick: ($event: any) => (_ctx.addToCollect(shoppingCartItem)),
                                  isLike: !!shoppingCartItem.IsInCmdyCollect,
                                  width: '20px',
                                  iconType: 'circle'
                                }, null, 8, ["onClick", "isLike"]),
                                _createVNode(_component_Icon, {
                                  iconName: "circle_close",
                                  onClick: ($event: any) => (
                            _ctx.itemDelete(shoppingCartItem.OrderShoppingCartId)
                          ),
                                  width: '20px'
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_UnderLine, { class: "w-auto ml-0 mb-5" }),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'package',
                                        width: '20px'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_43, " 禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _createVNode(_component_SquareItemFullImage, {
                                        width: '80px',
                                        customClass: 'square-photo-content-no-cursor'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_46, _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                    (_ctx.step == 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "hidden w-[32px] text-xs text-primary-color cursor-pointer",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                        }, "編輯"))
                                      : _createCommentVNode("", true),
                                    _hoisted_47
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal * shoppingCartItem.PackageCmdyList[0].CmdyQty), 1),
                                  _hoisted_50
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", _hoisted_52, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_55, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: addOnCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                          _createElementVNode("div", _hoisted_60, [
                                            _createVNode(_component_Icon, {
                                              iconName: 'add_on',
                                              width: '20px'
                                            })
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  addOnCmdyItem.CmdyQty === 0
                              }])
                                          }, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                          _hoisted_62,
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "text-xs text-primary-color cursor-pointer",
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                              }, "編輯"))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_63, [
                                        _createVNode(_component_InputWithButton, {
                                          style: {"width":"120px"},
                                          maxNumber: addOnCmdyItem.MaxAddOnQtyPerOrder,
                                          modelValue: addOnCmdyItem.CmdyQty,
                                          "onUpdate:modelValue": ($event: any) => ((addOnCmdyItem.CmdyQty) = $event),
                                          onAddClick: ($event: any) => (_ctx.addOnItemUpdate(addOnCmdyItem, 'add')),
                                          onSubtractClick: ($event: any) => (_ctx.addOnItemUpdate(addOnCmdyItem, 'subtract')),
                                          onBlur: ($event: any) => (_ctx.addOnItemUpdate(addOnCmdyItem, 'update'))
                                        }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                        _createElementVNode("div", _hoisted_64, [
                                          (
                                addOnCmdyItem.UnitFeeOri !==
                                addOnCmdyItem.UnitFeeReal
                              )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeOri * addOnCmdyItem.CmdyQty), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_66, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_67, [
                                          _createVNode(_component_Icon, {
                                            iconName: "circle_close",
                                            onClick: ($event: any) => (
                                _ctx.itemDelete(
                                  addOnCmdyItem.OrderShoppingCartId,
                                  'addOn'
                                )
                              ),
                                            width: '20px'
                                          }, null, 8, ["onClick"])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex py-[20px]"])
                                }, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("div", _hoisted_76, [
                                            _createVNode(_component_Icon, {
                                              iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                              width: '20px'
                                            }, null, 8, ["iconName"])
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_77, [
                                          _hoisted_78,
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "text-xs text-primary-color cursor-pointer",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                              }, "編輯"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass([[
                              {
                                hidden: giveawayCmdyItem.IsOutOfStock === false
                              }
                            ], "flex ml-[26px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                        }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                      ]),
                                      _createElementVNode("div", _hoisted_79, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[60px] font-medium text-gary-text-color text-base text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_80, [
                                          (
                                giveawayCmdyItem.UnitFeeOri !==
                                giveawayCmdyItem.UnitFeeReal
                              )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, " NT. " + _toDisplayString(giveawayCmdyItem.UnitFeeOri), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left", [
                                {
                                  'text-black-400-color':
                                    giveawayCmdyItem.CmdyQty === 0
                                }
                              ]])
                                          }, " NT. " + _toDisplayString(giveawayCmdyItem.UnitFeeReal * giveawayCmdyItem.CmdyQty), 3)
                                        ]),
                                        (_ctx.step == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _createVNode(_component_Icon, {
                                                class: "hidden",
                                                iconName: "circle_close",
                                                width: '20px'
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount +
                    _ctx.getListAmount(shoppingCartItem.AddOnCmdyList) +
                    _ctx.getListAmount(shoppingCartItem.PackageCmdyList)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createVNode(_component_CheckBox, {
                            modelValue: shoppingCartItem.Checked,
                            "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_89),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createElementVNode("div", {
                                    class: "text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 9, _hoisted_95),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 9, _hoisted_96),
                                  (!shoppingCartItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_98, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                            _hoisted_100,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                            _hoisted_102,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_103, _hoisted_107))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                      (!shoppingCartItem.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(shoppingCartItem)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        onClick: ($event: any) => (_ctx.addToCollect(shoppingCartItem)),
                                        isLike: !!shoppingCartItem.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(shoppingCartItem.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_109, [
                              _createVNode(_component_InputWithButton, {
                                style: {"width":"120px"},
                                modelValue: shoppingCartItem.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addClick(shoppingCartItem)),
                                onSubtractClick: ($event: any) => (_ctx.subtractClick(shoppingCartItem)),
                                onBlur: ($event: any) => (_ctx.itemUpdate(shoppingCartItem))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_110, [
                                (
                            shoppingCartItem.UnitFeeOri !==
                            shoppingCartItem.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeOri * shoppingCartItem.CmdyQty), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_112, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1)
                              ])
                            ])
                          ]),
                          (shoppingCartItem.PackageCmdyList.length !== 0)
                            ? (_openBlock(), _createBlock(_component_UnderLine, {
                                key: 0,
                                class: "hidden w-auto ml-1"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _hoisted_114,
                            _createElementVNode("div", _hoisted_115, [
                              _createVNode(_component_SquareItemFullImage, {
                                width: '60px',
                                customClass: 'square-photo-content-no-cursor'
                              })
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, [
                                  _createElementVNode("div", _hoisted_119, [
                                    _createElementVNode("div", _hoisted_120, [
                                      _createElementVNode("div", _hoisted_121, [
                                        _createVNode(_component_Icon, {
                                          class: "mr-1.5",
                                          iconName: "package",
                                          width: '20px'
                                        }),
                                        _createTextVNode("禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_122, [
                                        _createElementVNode("div", _hoisted_123, _toDisplayString(shoppingCartItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                        (_ctx.step == 1)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "hidden w-[32px] text-xs text-primary-color cursor-pointer",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                            }, "編輯"))
                                          : _createCommentVNode("", true),
                                        _hoisted_124
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_125, [
                                  _createElementVNode("div", _hoisted_126, [
                                    (
                            shoppingCartItem.PackageCmdyList[0].UnitFeeOri !==
                            shoppingCartItem.PackageCmdyList[0].UnitFeeReal
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeOri * shoppingCartItem.PackageCmdyList[0].CmdyQty), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_128, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal * shoppingCartItem.PackageCmdyList[0].CmdyQty), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", _hoisted_130, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_132))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_133, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: addOnCmdyItem.CmdyImage.MobileWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_134, [
                                    _createElementVNode("div", _hoisted_135, [
                                      _createElementVNode("div", _hoisted_136, [
                                        _createElementVNode("div", _hoisted_137, [
                                          _createElementVNode("div", _hoisted_138, [
                                            _createElementVNode("div", _hoisted_139, [
                                              _createElementVNode("div", _hoisted_140, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 'add_on',
                                                  width: '20px'
                                                })
                                              ]),
                                              _createElementVNode("span", _hoisted_141, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                            ]),
                                            _hoisted_142
                                          ]),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                                _createVNode(_component_Icon, {
                                                  iconName: "circle_close",
                                                  onClick: ($event: any) => (
                                  _ctx.itemDelete(
                                    shoppingCartItem.OrderShoppingCartId
                                  )
                                ),
                                                  width: '20px'
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_144, [
                                        _createVNode(_component_InputWithButton, {
                                          style: {"width":"120px"},
                                          modelValue: addOnCmdyItem.CmdyQty,
                                          "onUpdate:modelValue": ($event: any) => ((addOnCmdyItem.CmdyQty) = $event),
                                          onAddClick: ($event: any) => (_ctx.addClick(addOnCmdyItem)),
                                          onSubtractClick: ($event: any) => (_ctx.subtractClick(addOnCmdyItem)),
                                          onBlur: ($event: any) => (_ctx.itemUpdate(addOnCmdyItem))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                        _createElementVNode("div", _hoisted_145, [
                                          _createElementVNode("div", _hoisted_146, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeOri * addOnCmdyItem.CmdyQty), 1),
                                          _createElementVNode("div", _hoisted_147, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px] flex-row pt-5 pb-5"])
                                }, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_149))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_150))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_151, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_152, [
                                    _createElementVNode("div", _hoisted_153, [
                                      _createElementVNode("div", _hoisted_154, [
                                        _createElementVNode("div", _hoisted_155, [
                                          _createElementVNode("div", _hoisted_156, [
                                            _createElementVNode("div", _hoisted_157, [
                                              _createElementVNode("div", _hoisted_158, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 
                                      giveawayCmdyItem.CmdyQty == 0
                                        ? 'giveaway_gray'
                                        : 'giveaway_black'
                                    ,
                                                  width: '20px'
                                                }, null, 8, ["iconName"])
                                              ]),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                    'text-black-400-color':
                                      giveawayCmdyItem.CmdyQty === 0
                                  }])
                                              }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                            ]),
                                            _hoisted_159,
                                            _createElementVNode("span", {
                                              class: _normalizeClass([[
                                  {
                                    hidden:
                                      giveawayCmdyItem.IsOutOfStock === false
                                  }
                                ], "flex ml-[26px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                            }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                          ]),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                                _createVNode(_component_Icon, {
                                                  class: "hidden",
                                                  iconName: "circle_close",
                                                  width: '20px'
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_161, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[110px] font-medium text-gary-text-color text-base text-center", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_162, [
                                          _createElementVNode("div", _hoisted_163, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeOri * giveawayCmdyItem.CmdyQty), 1),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal * giveawayCmdyItem.CmdyQty), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("div", _hoisted_165, [
                          _hoisted_166,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount +
                    _ctx.getListAmount(shoppingCartItem.AddOnCmdyList) +
                    _ctx.getListAmount(shoppingCartItem.PackageCmdyList)), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.selectedAvailableAddOnCmdyList?.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createVNode(_component_Icon, {
                          iconName: 'add_on',
                          width: '20px'
                        })
                      ]),
                      _hoisted_169
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAvailableAddOnCmdyList, (availableAddOnCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: availableAddOnCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("div", _hoisted_172, [
                          _createVNode(_component_CheckBox, {
                            modelValue: availableAddOnCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(availableAddOnCmdy, 'AddOn'))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: availableAddOnCmdy.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_173),
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("div", _hoisted_175, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(availableAddOnCmdy, 'AddOn')),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_177, [
                                _createElementVNode("div", _hoisted_178, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'add_on',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_179, _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdySubName)), 1),
                              (!availableAddOnCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_180, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_181, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_182, [
                                        _hoisted_183,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_184, [
                                        _hoisted_185,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_186, _hoisted_190))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_176),
                            _createElementVNode("div", _hoisted_191, [
                              _createVNode(_component_InputWithButton, {
                                style: {"width":"120px"},
                                maxNumber: availableAddOnCmdy.MaxAddOnQtyPerOrder,
                                modelValue: availableAddOnCmdy.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'add')),
                                onSubtractClick: ($event: any) => (
                          _ctx.addOnItemUpdate(availableAddOnCmdy, 'subtract')
                        ),
                                onBlur: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'update'))
                              }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_192, [
                                (
                            availableAddOnCmdy.UnitFeeOri !==
                            availableAddOnCmdy.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_193, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeOri), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_194, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal), 1)
                              ]),
                              _createElementVNode("div", _hoisted_195, [
                                _createVNode(_component_Icon, {
                                  iconName: "circle_close",
                                  onClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'delete')),
                                  width: '20px'
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0 mt-3" }),
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _createVNode(_component_Icon, {
                            iconName: "tag_gold",
                            width: '20px'
                          }),
                          _hoisted_198
                        ]),
                        _createElementVNode("div", _hoisted_199, [
                          _hoisted_200,
                          _createTextVNode(" NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal * availableAddOnCmdy.CmdyQty), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_201, [
                      _createElementVNode("div", _hoisted_202, [
                        _createElementVNode("div", _hoisted_203, [
                          _createVNode(_component_CheckBox, {
                            modelValue: availableAddOnCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: availableAddOnCmdy.CmdyImage.MobileWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_204),
                        _createElementVNode("div", _hoisted_205, [
                          _createElementVNode("div", _hoisted_206, [
                            _createElementVNode("div", _hoisted_207, [
                              _createElementVNode("div", _hoisted_208, [
                                _createElementVNode("div", _hoisted_209, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                                  }, [
                                    _createElementVNode("div", _hoisted_211, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'add_on',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdyName)), 1)
                                  ], 8, _hoisted_210),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                                  }, _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdySubName)), 9, _hoisted_212),
                                  (!availableAddOnCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_213, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(
                                availableAddOnCmdy.EditorPortfolioName
                              )), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_214, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_215, [
                                            _hoisted_216,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_217, [
                                            _hoisted_218,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_219, _hoisted_223))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                      _createVNode(_component_Icon, {
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.addOnItemUpdate(availableAddOnCmdy, 'delete')
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_225, [
                              _createVNode(_component_InputWithButton, {
                                style: {"width":"120px"},
                                maxNumber: availableAddOnCmdy.MaxAddOnQtyPerOrder,
                                modelValue: availableAddOnCmdy.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'add')),
                                onSubtractClick: ($event: any) => (
                          _ctx.addOnItemUpdate(availableAddOnCmdy, 'subtract')
                        ),
                                onBlur: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'update'))
                              }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_226, [
                                (
                            availableAddOnCmdy.UnitFeeOri !==
                            availableAddOnCmdy.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_227, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeOri), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_228, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_229, [
                        _createElementVNode("div", _hoisted_230, [
                          _createVNode(_component_Icon, {
                            iconName: "tag_gold",
                            width: '20px'
                          }),
                          _hoisted_231
                        ]),
                        _createElementVNode("div", _hoisted_232, [
                          _hoisted_233,
                          _createTextVNode(" NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal * availableAddOnCmdy.CmdyQty), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.giveawayCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_234, [
                      _createElementVNode("div", _hoisted_235, [
                        _createVNode(_component_Icon, {
                          iconName: 'giveaway_black',
                          width: '20px'
                        })
                      ]),
                      _hoisted_236
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayCmdyListFromCalc, (giveawayCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: giveawayCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_237, [
                      _createElementVNode("div", _hoisted_238, [
                        _hoisted_239,
                        _createElementVNode("div", _hoisted_240, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_241, [
                          _createElementVNode("div", _hoisted_242, [
                            _createElementVNode("div", _hoisted_243, [
                              _createElementVNode("div", _hoisted_244, [
                                _createElementVNode("div", _hoisted_245, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'giveaway_black',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_246, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                              (!giveawayCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_247, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_248, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_249, [
                                        _hoisted_250,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_251, [
                                        _hoisted_252,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_253, _hoisted_257))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_258, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_259, [
                      _createElementVNode("div", _hoisted_260, [
                        _createElementVNode("div", _hoisted_261, [
                          _createVNode(_component_CheckBox, { class: "hidden" })
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ], 8, _hoisted_262),
                        _createElementVNode("div", _hoisted_263, [
                          _createElementVNode("div", _hoisted_264, [
                            _createElementVNode("div", _hoisted_265, [
                              _createElementVNode("div", _hoisted_266, [
                                _createElementVNode("div", _hoisted_267, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                                  }, [
                                    _createVNode(_component_Icon, {
                                      class: "mr-1.5",
                                      iconName: 'giveaway_black',
                                      width: '20px'
                                    }),
                                    _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                                  ], 8, _hoisted_268),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                                  }, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 9, _hoisted_269),
                                  (!giveawayCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_270, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_271, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_272, [
                                            _hoisted_273,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_274, [
                                            _hoisted_275,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_276, _hoisted_280))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                                      (!giveawayCmdy.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "hidden",
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(giveawayCmdy)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        class: "hidden",
                                        onClick: ($event: any) => (_ctx.addToCollect(giveawayCmdy)),
                                        isLike: !!giveawayCmdy.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        class: "hidden",
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(giveawayCmdy.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_282, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.step == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyListFromCalc, (shoppingCartItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_284, [
                      _createElementVNode("div", _hoisted_285, [
                        _hoisted_286,
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_287),
                        _createElementVNode("div", _hoisted_288, [
                          _createElementVNode("div", _hoisted_289, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem)),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 1),
                              _createElementVNode("div", _hoisted_292, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 1),
                              (!shoppingCartItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_293, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_294, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_295, [
                                        _hoisted_296,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_297, [
                                        _hoisted_298,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_299, _hoisted_303))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_290),
                            _createElementVNode("div", _hoisted_304, [
                              _createElementVNode("div", _hoisted_305, _toDisplayString(shoppingCartItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_306, [
                                _hoisted_307,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right", [{'line-through text-light-gary-text-color': shoppingCartItem.Discount > 0}]])
                                }, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 3),
                                (shoppingCartItem.Discount > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_308, " NT. " + _toDisplayString((shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty) - shoppingCartItem.Discount), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_309, [
                            _hoisted_310,
                            _hoisted_311,
                            _createElementVNode("div", _hoisted_312, [
                              _createVNode(_component_UnderLine, { class: "w-auto ml-[111px] sm:ml-0 mb-5" }),
                              _createElementVNode("div", _hoisted_313, [
                                _createElementVNode("div", _hoisted_314, [
                                  _createElementVNode("div", _hoisted_315, [
                                    _createElementVNode("div", _hoisted_316, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'package',
                                        width: '20px'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_317, " 禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_318, [
                                    _createElementVNode("div", _hoisted_319, [
                                      _createVNode(_component_SquareItemFullImage, {
                                        width: '80px',
                                        customClass: 'square-photo-content-no-cursor'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_320, _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                    _hoisted_321,
                                    _hoisted_322
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_323, [
                                  _createElementVNode("div", _hoisted_324, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal* shoppingCartItem.PackageCmdyList[0].CmdyQty), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", _hoisted_326, [
                                  _hoisted_327,
                                  _createElementVNode("div", _hoisted_328, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: addOnCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_329, [
                                    _createElementVNode("div", _hoisted_330, [
                                      _createElementVNode("div", _hoisted_331, [
                                        _createElementVNode("div", _hoisted_332, [
                                          _createElementVNode("div", _hoisted_333, [
                                            _createVNode(_component_Icon, {
                                              iconName: 'add_on',
                                              width: '20px'
                                            })
                                          ]),
                                          _createElementVNode("span", _hoisted_334, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                        ]),
                                        _hoisted_335
                                      ]),
                                      _createElementVNode("div", _hoisted_336, [
                                        _createElementVNode("div", _hoisted_337, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                        _createElementVNode("div", _hoisted_338, [
                                          _createElementVNode("div", _hoisted_339, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px]"])
                                }, [
                                  _hoisted_341,
                                  _createElementVNode("div", _hoisted_342, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_343, [
                                    _createElementVNode("div", _hoisted_344, [
                                      _createElementVNode("div", _hoisted_345, [
                                        _createElementVNode("div", _hoisted_346, [
                                          _createElementVNode("div", _hoisted_347, [
                                            _createVNode(_component_Icon, {
                                              iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                              width: '20px'
                                            }, null, 8, ["iconName"])
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_348, [
                                          _hoisted_349,
                                          _createElementVNode("div", {
                                            class: _normalizeClass([[
                                {
                                  hidden:
                                    giveawayCmdyItem.IsOutOfStock === false
                                }
                              ], "flex ml-[25px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                          }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_350, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_351, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_352, [
                        _createElementVNode("div", _hoisted_353, [
                          _hoisted_354,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_355, [
                      _createElementVNode("div", _hoisted_356, [
                        _hoisted_357,
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_358),
                        _createElementVNode("div", _hoisted_359, [
                          _createElementVNode("div", _hoisted_360, [
                            _createElementVNode("div", _hoisted_361, [
                              _createElementVNode("div", _hoisted_362, [
                                _createElementVNode("div", _hoisted_363, [
                                  _createElementVNode("div", {
                                    class: "text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 9, _hoisted_364),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 9, _hoisted_365),
                                  (!shoppingCartItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_366, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_367, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_368, [
                                            _hoisted_369,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_370, [
                                            _hoisted_371,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_372, _hoisted_376))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_377, [
                              _createElementVNode("div", _hoisted_378, _toDisplayString(shoppingCartItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_379, [
                                _createElementVNode("div", _hoisted_380, [
                                  _createElementVNode("div", _hoisted_381, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1),
                                  (shoppingCartItem.Discount > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_382, " NT. " + _toDisplayString((shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty) - shoppingCartItem.Discount), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          (shoppingCartItem.PackageCmdyList?.length !== 0)
                            ? (_openBlock(), _createBlock(_component_UnderLine, {
                                key: 0,
                                class: "w-auto ml-1"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_383, [
                            _hoisted_384,
                            _createElementVNode("div", _hoisted_385, [
                              _createVNode(_component_SquareItemFullImage, {
                                width: '60px',
                                customClass: 'square-photo-content-no-cursor'
                              })
                            ]),
                            _createElementVNode("div", _hoisted_386, [
                              _createElementVNode("div", _hoisted_387, [
                                _createElementVNode("div", _hoisted_388, [
                                  _createElementVNode("div", _hoisted_389, [
                                    _createElementVNode("div", _hoisted_390, [
                                      _createElementVNode("div", _hoisted_391, [
                                        _createVNode(_component_Icon, {
                                          class: "mr-1.5",
                                          iconName: "package",
                                          width: '20px'
                                        }),
                                        _createTextVNode("禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_392, [
                                        _createElementVNode("div", _hoisted_393, _toDisplayString(shoppingCartItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                        _hoisted_394
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_395, [
                                  _createElementVNode("div", _hoisted_396, [
                                    _createElementVNode("div", _hoisted_397, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal * shoppingCartItem.PackageCmdyList[0].CmdyQty), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createBlock(_component_UnderLine, {
                            key: 1,
                            class: "w-auto m-0"
                          }))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_398, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", _hoisted_399, [
                                  _hoisted_400,
                                  _createElementVNode("div", _hoisted_401, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      customClass: '',
                                      image: addOnCmdyItem.CmdyImage.MobileWeb
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_402, [
                                    _createElementVNode("div", _hoisted_403, [
                                      _createElementVNode("div", _hoisted_404, [
                                        _createElementVNode("div", _hoisted_405, [
                                          _createElementVNode("div", _hoisted_406, [
                                            _createElementVNode("div", _hoisted_407, [
                                              _createVNode(_component_Icon, {
                                                class: "mr-1.5",
                                                iconName: "add_on",
                                                width: '20px'
                                              }),
                                              _createTextVNode(" 加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                            ]),
                                            _hoisted_408
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_409, [
                                        _createElementVNode("div", _hoisted_410, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                        _createElementVNode("div", _hoisted_411, [
                                          _createElementVNode("div", _hoisted_412, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_413, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "flex flex-row",
                                key: giveawayCmdyItem.CmdyId
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px] flex-row pt-5 pb-5"])
                                }, [
                                  _hoisted_414,
                                  _createElementVNode("div", _hoisted_415, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: giveawayCmdyItem.CmdyImage.MobileWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_416, [
                                    _createElementVNode("div", _hoisted_417, [
                                      _createElementVNode("div", _hoisted_418, [
                                        _createElementVNode("div", _hoisted_419, [
                                          _createElementVNode("div", _hoisted_420, [
                                            _createElementVNode("div", _hoisted_421, [
                                              _createElementVNode("div", _hoisted_422, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 
                                      giveawayCmdyItem.CmdyQty == 0
                                        ? 'giveaway_gray'
                                        : 'giveaway_black'
                                    ,
                                                  width: '20px'
                                                }, null, 8, ["iconName"])
                                              ]),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                    'text-black-400-color':
                                      giveawayCmdyItem.CmdyQty === 0
                                  }])
                                              }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                            ]),
                                            _hoisted_423,
                                            _createElementVNode("div", {
                                              class: _normalizeClass([[
                                  {
                                    hidden:
                                      giveawayCmdyItem.IsOutOfStock === false
                                  }
                                ], "flex items-center mb-1.5 font-medium text-xs text-dot-red"])
                                            }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_424, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_425, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_426, [
                        _createElementVNode("div", _hoisted_427, [
                          _hoisted_428,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.addOnCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_429, [
                      _createVNode(_component_Icon, {
                        class: "mr-2.5",
                        iconName: 'add_on',
                        width: '20px'
                      }),
                      _hoisted_430
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addOnCmdyListFromCalc, (addOnCmdyItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_431, [
                      _createElementVNode("div", _hoisted_432, [
                        _hoisted_433,
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn'))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: addOnCmdyItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_434),
                        _createElementVNode("div", _hoisted_435, [
                          _createElementVNode("div", _hoisted_436, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn')),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_438, [
                                _createElementVNode("div", _hoisted_439, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'add_on',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_440, _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdySubName)), 1),
                              (!addOnCmdyItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_441, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_442, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_443, [
                                        _hoisted_444,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_445, [
                                        _hoisted_446,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_447, _hoisted_451))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_437),
                            _createElementVNode("div", _hoisted_452, [
                              _createElementVNode("div", _hoisted_453, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_454, [
                                _createElementVNode("div", _hoisted_455, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_456, [
                        _createElementVNode("div", _hoisted_457, [
                          _hoisted_458,
                          _createTextVNode(" NT. " + _toDisplayString(addOnCmdyItem.TotalAmount), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_459, [
                      _createElementVNode("div", _hoisted_460, [
                        _hoisted_461,
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: addOnCmdyItem.CmdyImage.MobileWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_462),
                        _createElementVNode("div", _hoisted_463, [
                          _createElementVNode("div", _hoisted_464, [
                            _createElementVNode("div", _hoisted_465, [
                              _createElementVNode("div", _hoisted_466, [
                                _createElementVNode("div", _hoisted_467, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                                  }, [
                                    _createElementVNode("div", _hoisted_469, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'add_on',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdyName)), 1)
                                  ], 8, _hoisted_468),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdySubName)), 9, _hoisted_470),
                                  (!addOnCmdyItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_471, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_472, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_473, [
                                            _hoisted_474,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_475, [
                                            _hoisted_476,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_477, _hoisted_481))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_482, [
                              _createElementVNode("div", _hoisted_483, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_484, [
                                _createElementVNode("div", _hoisted_485, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_486, [
                        _createElementVNode("div", _hoisted_487, [
                          _hoisted_488,
                          _createTextVNode(" NT. " + _toDisplayString(addOnCmdyItem.TotalAmount), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.giveawayCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_489, [
                      _createVNode(_component_Icon, {
                        class: "mr-2.5",
                        iconName: 'giveaway_black',
                        width: '20px'
                      }),
                      _hoisted_490
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayCmdyListFromCalc, (giveawayCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: giveawayCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_491, [
                      _createElementVNode("div", _hoisted_492, [
                        _createElementVNode("div", _hoisted_493, [
                          _createVNode(_component_CheckBox, {
                            modelValue: giveawayCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((giveawayCmdy.Checked) = $event),
                            class: "hidden"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_494, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_495, [
                          _createElementVNode("div", _hoisted_496, [
                            _createElementVNode("div", _hoisted_497, [
                              _createElementVNode("div", _hoisted_498, [
                                _createElementVNode("div", _hoisted_499, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'giveaway_black',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_500, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                              (!giveawayCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_501, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_502, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_503, [
                                        _hoisted_504,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_505, [
                                        _hoisted_506,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_507, _hoisted_511))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_512, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_513, [
                      _createElementVNode("div", _hoisted_514, [
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_515),
                        _createElementVNode("div", _hoisted_516, [
                          _createElementVNode("div", _hoisted_517, [
                            _createElementVNode("div", _hoisted_518, [
                              _createElementVNode("div", _hoisted_519, [
                                _createElementVNode("div", _hoisted_520, [
                                  _createElementVNode("div", _hoisted_521, [
                                    _createElementVNode("div", _hoisted_522, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'giveaway_black',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_523, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                                  (!giveawayCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_524, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_525, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_526, [
                                            _hoisted_527,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_528, [
                                            _hoisted_529,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createElementBlock("ul", _hoisted_530, _hoisted_534))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_535, [
                                      (!giveawayCmdy.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "hidden",
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(giveawayCmdy)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        class: "hidden",
                                        onClick: ($event: any) => (_ctx.addToCollect(giveawayCmdy)),
                                        isLike: !!giveawayCmdy.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        class: "hidden",
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(giveawayCmdy.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_536, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.step == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_537, [
              _createElementVNode("div", _hoisted_538, [
                _createElementVNode("div", _hoisted_539, [
                  _createElementVNode("div", _hoisted_540, [
                    _createElementVNode("div", _hoisted_541, [
                      _hoisted_542,
                      _createElementVNode("div", _hoisted_543, " NT. " + _toDisplayString(_ctx.getSelectPrice.CmdyAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_544, [
                      _hoisted_545,
                      _createElementVNode("div", _hoisted_546, " - NT. " + _toDisplayString(_ctx.getSelectPrice.Discount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_547, [
                    _createElementVNode("div", _hoisted_548, [
                      _hoisted_549,
                      _createElementVNode("div", _hoisted_550, " NT. " + _toDisplayString(_ctx.getSelectPrice.CmdyAmt - _ctx.getSelectPrice.Discount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_551, [
                      _createElementVNode("div", {
                        class: "bg-primary-color h-2 rounded-full",
                        style: _normalizeStyle({ width: `${_ctx.getSelectPrice.ForFree}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("div", {
                      class: "pt-[11px] text-xs text-gary-text-color tracking-[.08em] font-bold whitespace-pre-wrap leading-5",
                      innerHTML: _ctx.getSelectPrice.ForFreeDesc
                    }, null, 8, _hoisted_552),
                    _createElementVNode("div", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.router.push({ name: 'home' }))),
                      class: "text-gary-text-color font-medium sm:font-bold my-[20px] cursor-pointer"
                    }, " < 繼續購物 "),
                    _createElementVNode("div", {
                      class: _normalizeClass(["leading-[50px] text-center bg-gary-text-color text-white rounded-[10px] text-base cursor-pointer hover:bg-primary-color active:bg-primary-color", {
                  'cursor-not-allowed': _ctx.getSelectedItem.length === 0,
                  'hover:bg-gary-text-color': _ctx.getSelectedItem.length === 0,
                  'active:bg-gary-text-color': _ctx.getSelectedItem.length === 0
                }]),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getSelectedItem.length !== 0 && _ctx.goStep(2)))
                    }, " 去結帳 ", 2)
                  ])
                ])
              ]),
              (_ctx.availableAddOnCmdyListFromCalc.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_553, [
                    _hoisted_554,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableAddOnCmdyListFromCalc, (addOnCmdyItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-row cursor-pointer",
                        key: addOnCmdyItem.CmdyId,
                        onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn'))
                      }, [
                        _createElementVNode("div", _hoisted_556, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            class: "pr-2",
                            customClass: '',
                            image: addOnCmdyItem.CmdyImage.PcWeb
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_557, [
                          _createElementVNode("div", _hoisted_558, [
                            _createElementVNode("div", _hoisted_559, _toDisplayString(addOnCmdyItem.CmdyName), 1),
                            _createElementVNode("div", _hoisted_560, [
                              _hoisted_561,
                              _createElementVNode("span", null, _toDisplayString(addOnCmdyItem.UnitFeeReal), 1),
                              (
                      addOnCmdyItem.UnitFeeReal !== addOnCmdyItem.UnitFeeOri
                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_562, [
                                    _hoisted_563,
                                    _createElementVNode("span", null, _toDisplayString(addOnCmdyItem.UnitFeeOri), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_564, [
                            _createVNode(_component_Icon, {
                              onClick: _withModifiers(($event: any) => (_ctx.addAddOn(addOnCmdyItem)), ["stop"]),
                              iconName: "circle_add",
                              width: '30px'
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ], 8, _hoisted_555))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_565, [
                _hoisted_566,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedList, (recommendedItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-row cursor-pointer",
                    key: recommendedItem,
                    onClick: ($event: any) => (_ctx.goProductDetail(recommendedItem))
                  }, [
                    _createElementVNode("div", _hoisted_568, [
                      _createVNode(_component_SquareItemFullImage, {
                        width: '80px',
                        class: "pr-2",
                        customClass: '',
                        image: recommendedItem.Image.PcWeb
                      }, null, 8, ["image"])
                    ]),
                    _createElementVNode("div", _hoisted_569, [
                      _createElementVNode("div", _hoisted_570, [
                        _createElementVNode("div", _hoisted_571, _toDisplayString(recommendedItem.Name), 1),
                        _createElementVNode("div", _hoisted_572, _toDisplayString(recommendedItem.SubName), 1),
                        _createElementVNode("div", _hoisted_573, [
                          _hoisted_574,
                          _createElementVNode("span", null, _toDisplayString(recommendedItem.UnitFeeReal), 1),
                          (
                      recommendedItem.UnitFeeReal !== recommendedItem.UnitFeeOri
                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_575, [
                                _hoisted_576,
                                _createElementVNode("span", null, _toDisplayString(recommendedItem.UnitFeeOri), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_577, [
                        _createVNode(_component_Icon, {
                          iconName: "circle_add",
                          width: '30px'
                        })
                      ])
                    ])
                  ], 8, _hoisted_567))
                }), 128)),
                _createElementVNode("div", {
                  class: "cursor-pointer text-center items-center m-auto rounded-[10px] h-[39px] w-[139px] leading-[35px] border-[1px] tracking-[.1em] border-gary-text-color text-gary-text-color text-sm",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goIpInspiration()))
                }, " View More ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.step == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_578, [
              _createElementVNode("div", _hoisted_579, [
                _createElementVNode("div", _hoisted_580, [
                  _hoisted_581,
                  _createVNode(_component_Input, {
                    label: '姓名',
                    class: "under-line mb-5",
                    width: '100%',
                    required: true,
                    placeholder: "請輸入姓名",
                    modelValue: _ctx.buyerName,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.buyerName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_582, [
                    _hoisted_583,
                    _createElementVNode("div", _hoisted_584, _toDisplayString(_ctx.store.state.userInfo.Mobile), 1)
                  ]),
                  _createVNode(_component_Input, {
                    label: 'E-mail',
                    class: "under-line pb-1",
                    width: '100%',
                    required: true,
                    placeholder: "請輸入email",
                    modelValue: _ctx.buyerEmail,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.buyerEmail) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_585,
                  _createVNode(_component_AddressInput, {
                    deliveryAddr: _ctx.buyerAddr,
                    "onUpdate:deliveryAddr": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.buyerAddr) = $event)),
                    deliveryDist: _ctx.buyerDist,
                    "onUpdate:deliveryDist": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.buyerDist) = $event)),
                    deliveryCity: _ctx.buyerCity,
                    "onUpdate:deliveryCity": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.buyerCity) = $event)),
                    deliveryZip: _ctx.buyerZip,
                    "onUpdate:deliveryZip": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.buyerZip) = $event)),
                    required: true,
                    label: '地址'
                  }, null, 8, ["deliveryAddr", "deliveryDist", "deliveryCity", "deliveryZip"])
                ])
              ]),
              _createElementVNode("div", _hoisted_586, [
                _createElementVNode("div", _hoisted_587, [
                  _createElementVNode("div", _hoisted_588, [
                    _hoisted_589,
                    (_ctx.selectDeliveryType === 'EcPayCVS')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_590, " ・超商取貨需出示證件，請確實填寫。 "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Select, {
                    class: "my-3 w-full",
                    width: '100%',
                    itemList: _ctx.cartStore.state.deliveryTypeList,
                    itemValue: 'Code',
                    itemText: 'Desc',
                    modelValue: _ctx.selectDeliveryType,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectDeliveryType) = $event)),
                    onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.getFreight(_ctx.selectDeliveryType)))
                  }, null, 8, ["itemList", "modelValue"]),
                  _createElementVNode("div", {
                    class: "w-full hover:border-black active:border-black justify-between h-[100px] flex mb-2.5 pl-[16px] py-[16px] rounded-[4px] border-black-300-color border-solid border-[1px] cursor-pointer",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.goDeliveryListModal()))
                  }, [
                    (
                  _ctx.cartStore.state.shoppingCartDetailInfo.Delivery !==
                    undefined &&
                  (_ctx.selectDeliveryType === 'Home' ||
                    _ctx.selectDeliveryType === 'GainHowShopSeller')
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_591, [
                          _createElementVNode("div", _hoisted_592, [
                            _createElementVNode("div", _hoisted_593, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .ReceiverName), 1),
                            _createElementVNode("div", _hoisted_594, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .ReceiverMobile), 1)
                          ]),
                          (_ctx.selectDeliveryType === 'Home')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_595, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                      .DeliveryCity +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                      .DeliveryDist +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery.DeliveryAddr), 1))
                            : (_ctx.selectDeliveryType === 'GainHowShopSeller')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_596, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery.ShopInfo
                      .ShopName +
                    ' ' +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery.ShopInfo
                      .ShopAddr), 1))
                              : _createCommentVNode("", true)
                        ]))
                      : (
                  _ctx.selectDeliverySubType !== '' &&
                  _ctx.selectDeliveryType === 'EcPayCVS' &&
                  _ctx.cartStore.state.shoppingCartDetailInfo.Receiver !==
                    undefined &&
                  _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                    .ReceiverName !== ''
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_597, [
                            _createElementVNode("div", _hoisted_598, [
                              _createElementVNode("div", _hoisted_599, _toDisplayString(_ctx.selectDeliverySubTypeDesc), 1),
                              _createElementVNode("div", _hoisted_600, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .DeliveryDestName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_601, [
                              _createElementVNode("div", _hoisted_602, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverName || ''), 1)
                            ]),
                            _createElementVNode("div", _hoisted_603, [
                              _createElementVNode("div", _hoisted_604, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverMobile), 1),
                              (
                      _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverTel !== ''
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_605, _toDisplayString('/ ' +
                      _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverTel), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_ctx.selectDeliveryType === 'EcPayCVS')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_606, " 選擇門市資訊 "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_607, " 填寫收件資料 ")),
                    _createElementVNode("div", _hoisted_608, [
                      _createVNode(_component_Icon, {
                        iconName: "arrow_right",
                        width: '24px'
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_609, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "block px-[16px] py-[7px] w-full h-[80px] text-[13px] tracking-[.12em] text-gary-text-color placeholder:font-medium placeholder:text-black-400-color placeholder:tracking-[0.12em] rounded-md resize-none",
                      placeholder: "請輸入訂單備註",
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.remark) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.remark]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_610, [
                _createElementVNode("div", _hoisted_611, [
                  _hoisted_612,
                  _createElementVNode("div", _hoisted_613, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore.state.paymentTypeList, (paymentItem) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: paymentItem.Code,
                        text: paymentItem.Desc,
                        width: '20px',
                        inputValue: paymentItem,
                        modelValue: _ctx.selectPaymentType,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectPaymentType) = $event))
                      }, null, 8, ["text", "inputValue", "modelValue"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_614, [
                  _hoisted_615,
                  _createVNode(_component_Select, {
                    class: "my-3 w-full",
                    width: '100%',
                    itemList: _ctx.cartStore.state.invoiceTypeList,
                    itemValue: 'Code',
                    itemText: 'Desc',
                    modelValue: _ctx.selectInvoiceType,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.selectInvoiceType) = $event))
                  }, null, 8, ["itemList", "modelValue"]),
                  (_ctx.selectInvoiceType === 'Elec2')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_616, _hoisted_618))
                    : _createCommentVNode("", true),
                  (_ctx.selectInvoiceType === 'Elec2WithBarcode')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_619, [
                        _createElementVNode("div", _hoisted_620, [
                          _hoisted_621,
                          _createElementVNode("div", {
                            class: "hidden flex items-center text-xs text-breadcrumb-color pl-[24px] tracking-[.1em] font-normal cursor-pointer",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isSameMemberBarcode = !_ctx.isSameMemberBarcode))
                          }, [
                            _createVNode(_component_RadioButton, {
                              width: '12px',
                              inputValue: _ctx.isSameMemberBarcode,
                              modelValue: _ctx.isSameMemberBarcode,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isSameMemberBarcode) = $event))
                            }, null, 8, ["inputValue", "modelValue"]),
                            _hoisted_622
                          ])
                        ]),
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "mail",
                          height: "50px",
                          width: '100%',
                          modelValue: _ctx.invoiceCarrier,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.invoiceCarrier) = $event)),
                          placeholder: '請輸入手機條碼載具'
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectInvoiceType === 'Elec3')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_623, [
                        _hoisted_624,
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "number",
                          height: "50px",
                          width: '100%',
                          placeholder: '請輸入8碼統一編號',
                          modelValue: _ctx.invoiceBizNo,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.invoiceBizNo) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_625, [
                          _hoisted_626,
                          _createElementVNode("div", {
                            class: "flex items-center text-xs text-breadcrumb-color pl-[24px] tracking-[.1em] font-normal cursor-pointer",
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isSameMemberEmail = !_ctx.isSameMemberEmail))
                          }, [
                            _createVNode(_component_RadioButton, {
                              width: '12px',
                              inputValue: _ctx.isSameMemberEmail,
                              modelValue: _ctx.isSameMemberEmail,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isSameMemberEmail) = $event))
                            }, null, 8, ["inputValue", "modelValue"]),
                            _hoisted_627
                          ])
                        ]),
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "mail",
                          height: "50px",
                          width: '100%',
                          modelValue: _ctx.invoiceEmail,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.invoiceEmail) = $event)),
                          placeholder: '請輸入E-mail'
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_628, [
                _createElementVNode("div", {
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.goCouponSelectModal && _ctx.goCouponSelectModal(...args))),
                  class: "flex border-[1px] justify-between py-[15px] rounded-xl px-[15px] mb-[16px] cursor-pointer text-right font-medium sm:font-bold tracking-[.1em]"
                }, [
                  _createElementVNode("div", _hoisted_629, [
                    _createVNode(_component_Icon, { iconName: "tag_gold" }),
                    _hoisted_630
                  ]),
                  _createElementVNode("div", _hoisted_631, [
                    _createVNode(_component_Icon, {
                      iconName: "arrow_right",
                      width: '24px'
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_632, [
                  _createElementVNode("div", _hoisted_633, [
                    _createElementVNode("div", _hoisted_634, [
                      _hoisted_635,
                      _createElementVNode("div", _hoisted_636, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.TotalCmdyAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_637, [
                      _hoisted_638,
                      _createElementVNode("div", _hoisted_639, [
                        (_ctx.calcShoppingCartObject.TotalCmdyDiscount === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_640, " - NT. 0 "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calcShoppingCartObject.AppliedPromotionList, (selectCoupon) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: selectCoupon.PromotionCouponId,
                            class: "flex"
                          }, [
                            (selectCoupon.DiscountTarget === 'CmdyAmt')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_641, [
                                  _createTextVNode(_toDisplayString(selectCoupon.PromotionActivityName) + " ", 1),
                                  _createElementVNode("div", _hoisted_642, [
                                    _createVNode(_component_Icon, {
                                      onClick: ($event: any) => (_ctx.cancelCoupon(selectCoupon)),
                                      class: "cursor-pointer",
                                      iconName: "close_white",
                                      width: '16px'
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (selectCoupon.DiscountTarget === 'CmdyAmt')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_643, " - NT. " + _toDisplayString(selectCoupon.Discount), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_644, [
                      _hoisted_645,
                      _createElementVNode("div", _hoisted_646, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.FreightAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_647, [
                      _hoisted_648,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calcShoppingCartObject.AppliedPromotionList, (appliedPromotion) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: appliedPromotion.PromotionActivityId
                        }, [
                          (appliedPromotion.DiscountTarget === 'FreightAmt')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_649, [
                                _createTextVNode(_toDisplayString(appliedPromotion.PromotionActivityName), 1),
                                _createVNode(_component_Icon, {
                                  class: "hidden ml-[5px] cursor-pointer",
                                  iconName: "close_white",
                                  width: '16px'
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_650, " - NT. " + _toDisplayString(_ctx.calcShoppingCartObject.FreightDiscount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_651, [
                    _createElementVNode("div", _hoisted_652, [
                      _hoisted_653,
                      _createElementVNode("div", _hoisted_654, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.TotalShoppingCartAmount), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex mt-[30px] items-center cursor-pointer",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isAllowReceive = !_ctx.isAllowReceive))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowReceive,
                        modelValue: _ctx.isAllowReceive,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.isAllowReceive) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_655
                    ]),
                    _createElementVNode("div", {
                      class: "flex my-[6px] items-center cursor-pointer",
                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.isAllowReturn = !_ctx.isAllowReturn))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowReturn,
                        modelValue: _ctx.isAllowReturn,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.isAllowReturn) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_656
                    ]),
                    _createElementVNode("div", {
                      class: "flex mb-[30px] items-center cursor-pointer",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isAllowInfoCorrect = !_ctx.isAllowInfoCorrect))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowInfoCorrect,
                        modelValue: _ctx.isAllowInfoCorrect,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.isAllowInfoCorrect) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_657
                    ]),
                    _createElementVNode("div", {
                      class: "text-gary-text-color text-base font-medium sm:font-bold mt-[30px] mb-[20px] cursor-pointer",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goStep(1)))
                    }, " < 返回至購物車頁面 "),
                    _createElementVNode("div", {
                      class: "leading-9 sm:leading-[50px] text-center bg-gary-text-color text-white rounded-[10px] text-sm sm:text-base cursor-pointer hover:bg-primary-color active:bg-primary-color",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.order()))
                    }, " 確認付款 ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_AddOnModal, {
      show: _ctx.showAddOnModal,
      cmdyType: _ctx.selectedType,
      AddOnCmdyItem: _ctx.selectAddOnCmdy,
      page: 'shoppingCart',
      onOk: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showAddOnModal = false)),
      onCancel: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showAddOnModal = false))
    }, null, 8, ["show", "cmdyType", "AddOnCmdyItem"]),
    _createVNode(_component_DeliveryListModal, {
      show: _ctx.showDeliveryListModal,
      "onUpdate:show": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showDeliveryListModal) = $event)),
      deliveryType: _ctx.selectDeliveryType,
      "onUpdate:deliveryType": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.selectDeliveryType) = $event)),
      buyerName: _ctx.buyerName,
      "onUpdate:buyerName": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.buyerName) = $event)),
      buyerEmail: _ctx.buyerEmail,
      "onUpdate:buyerEmail": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.buyerEmail) = $event)),
      buyerCity: _ctx.buyerCity,
      "onUpdate:buyerCity": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.buyerCity) = $event)),
      buyerDist: _ctx.buyerDist,
      "onUpdate:buyerDist": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.buyerDist) = $event)),
      buyerZip: _ctx.buyerZip,
      "onUpdate:buyerZip": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.buyerZip) = $event)),
      buyerAddr: _ctx.buyerAddr,
      "onUpdate:buyerAddr": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.buyerAddr) = $event)),
      onOk: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showDeliveryListModal = false))
    }, null, 8, ["show", "deliveryType", "buyerName", "buyerEmail", "buyerCity", "buyerDist", "buyerZip", "buyerAddr"]),
    _createVNode(_component_SelectCouponModal, {
      show: _ctx.showSelectCouponModal,
      "onUpdate:show": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.showSelectCouponModal) = $event)),
      selectCouponList: _ctx.selectCouponList,
      "onUpdate:selectCouponList": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.selectCouponList) = $event)),
      cmdyCouponList: _ctx.calcShoppingCartObject.CmdyCouponList,
      "onUpdate:cmdyCouponList": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.calcShoppingCartObject.CmdyCouponList) = $event)),
      isUpdate: _ctx.couponIsUpdate,
      "onUpdate:isUpdate": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.couponIsUpdate) = $event)),
      onOk: _cache[63] || (_cache[63] = ($event: any) => (_ctx.showSelectCouponModal = false))
    }, null, 8, ["show", "selectCouponList", "cmdyCouponList", "isUpdate"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}